export default function ResearchDevelopment() {
  const researchAreas = [
    {
      icon: 'ri-test-tube-line',
      title: '飼料開発',
      description: '魚の成長と健康を最適化する高品質な飼料の研究開発',
      status: '継続中'
    },
    {
      icon: 'ri-dna-line',
      title: '品種改良',
      description: '環境適応性と成長速度に優れた品種の選抜と育成',
      status: '継続中'
    },
    {
      icon: 'ri-microscope-line',
      title: '病気予防',
      description: '免疫力向上と病気予防のための研究',
      status: '継続中'
    },
    {
      icon: 'ri-cpu-line',
      title: 'AI活用',
      description: '人工知能による最適な飼育管理システムの開発',
      status: '開発中'
    }
  ];

  return (
    <section className="py-24 px-6 bg-gradient-to-b from-[#F5F9F6] to-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-[#E8F5E9] mb-6">
            <i className="ri-lightbulb-line text-[#2D7A3E] text-lg mr-2"></i>
            <span className="text-[#2D7A3E] text-sm font-semibold whitespace-nowrap">研究開発</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#1A2332] mb-6">
            継続的な技術革新
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            筑波大学との共同研究により、常に最新の技術を取り入れ、<br className="hidden md:block" />
            より効率的で持続可能な養殖システムを追求しています。
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-20">
          {researchAreas.map((area, index) => (
            <div
              key={index}
              className="bg-white p-6 rounded-xl border border-[#E8F5E9] shadow-lg hover:shadow-xl transition-all duration-300"
            >
              <div className="w-14 h-14 bg-gradient-to-br from-[#2D7A3E] to-[#4CAF50] rounded-lg flex items-center justify-center mb-4">
                <i className={`${area.icon} text-white text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-[#1A2332] mb-3">{area.title}</h3>
              <p className="text-sm text-gray-600 mb-4 leading-relaxed">{area.description}</p>
              <div className="pt-4 border-t border-[#E8F5E9]">
                <span className="inline-flex items-center px-3 py-1 bg-[#E8F5E9] text-[#2D7A3E] text-xs font-semibold rounded-full whitespace-nowrap">
                  <i className="ri-time-line mr-1"></i>
                  {area.status}
                </span>
              </div>
            </div>
          ))}
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center mb-20">
          <div className="relative">
            <div className="rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/391897712535934b5267f07fe82a965a.jpg"
                alt="研究開発の様子"
                className="w-full h-[500px] object-cover object-top"
              />
            </div>
          </div>

          <div>
            <h3 className="text-3xl font-bold text-[#1A2332] mb-6">
              大学との共同研究体制
            </h3>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              筑波大学の研究チームと密接に連携し、最新の研究成果を実用化。学術的な知見と実践的な経験を融合させ、より優れた養殖技術を開発しています。
            </p>
            <div className="space-y-6">
              <div className="bg-white p-6 rounded-xl border border-[#E8F5E9] shadow-md">
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-[#2D7A3E] rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-book-open-line text-white text-xl"></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-bold text-[#1A2332] mb-2">学術論文の発表</h4>
                    <p className="text-sm text-gray-600 leading-relaxed">
                      研究成果を国内外の学術誌に発表し、養殖技術の発展に貢献
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white p-6 rounded-xl border border-[#E8F5E9] shadow-md">
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-[#2D7A3E] rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-graduation-cap-line text-white text-xl"></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-bold text-[#1A2332] mb-2">学生の受け入れ</h4>
                    <p className="text-sm text-gray-600 leading-relaxed">
                      大学院生の研究フィールドとして施設を提供し、次世代の人材育成に協力
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white p-6 rounded-xl border border-[#E8F5E9] shadow-md">
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-[#2D7A3E] rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-global-line text-white text-xl"></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-bold text-[#1A2332] mb-2">国際連携</h4>
                    <p className="text-sm text-gray-600 leading-relaxed">
                      海外の研究機関とも連携し、グローバルな視点で技術開発を推進
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-r from-[#2D7A3E] to-[#4CAF50] p-12 rounded-2xl text-white text-center">
          <h3 className="text-3xl font-bold mb-6">技術の社会実装を目指して</h3>
          <p className="text-lg opacity-95 mb-8 max-w-3xl mx-auto leading-relaxed">
            研究室で開発された技術を実際の生産現場で活用し、持続可能な食料生産システムとして社会に貢献します。
          </p>
          <div className="grid md:grid-cols-3 gap-8">
            <div>
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-flask-line text-white text-2xl"></i>
              </div>
              <p className="text-xl font-bold mb-2">基礎研究</p>
              <p className="text-sm opacity-90">大学での研究開発</p>
            </div>
            <div>
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-arrow-right-line text-white text-2xl"></i>
              </div>
              <p className="text-xl font-bold mb-2">実証実験</p>
              <p className="text-sm opacity-90">実際の施設での検証</p>
            </div>
            <div>
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-building-line text-white text-2xl"></i>
              </div>
              <p className="text-xl font-bold mb-2">社会実装</p>
              <p className="text-sm opacity-90">商業生産への展開</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}